export const NameListAPIURL = new URL('https://naamify-app-w3yys.ondigitalocean.app');